module.exports = __webpack_public_path__ + "img/hair_front_male_hairline_mask.dc6d22ef.png";